import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useContactForm } from "@/components/ContactFormModal";

export function CTASection() {
  const { t } = useTranslation();
  const { openContactForm } = useContactForm();
  return (
    <section className="py-24 md:py-32 bg-muted">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl mb-6">
            {t("cta.title")}
          </h2>
          <p className="text-xl text-muted-foreground mb-10 max-w-xl mx-auto">
            {t("cta.description")}
          </p>
          <div className="flex flex-col sm:flex-row sm:justify-center gap-3 sm:gap-4">
            <Button size="lg" className="h-12 px-8 text-base group w-full sm:w-auto" onClick={() => openContactForm({ page: "Home", button: "Book a Call", buttonPosition: "bottom" })}>
              {t("common.bookACall")}
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
            <Button size="lg" variant="outline" className="h-12 px-8 text-base w-full sm:w-auto" asChild>
              <a href="mailto:contact@shelpuk.com">
                Email
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
